import React from "react"
import { Col, Card, CardBody, CardTitle } from "reactstrap"
import ReactApexChart from "react-apexcharts/dist/react-apexcharts.cjs.js"

const ApexChart = ReactApexChart.default || ReactApexChart

const Piechart = ({ series }) => {
  const options = {
    labels: ["Pending", "In Transit", "Out For Delivery", "Delivered", "NDR"],
    colors: ["#f59e0b", "#3b82f6", "#6366f1", "#10b981", "#f43f5e"],
    theme: {
      mode: 'light',
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["#ffffff"]
    },
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      verticalAlign: "middle",
      floating: false,
      fontSize: "13px",
      offsetX: 0,
      offsetY: 0,
      labels: {
        colors: "#475569"
      }
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          chart: {
            height: 240,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  }

  return (
    <>
      <CardTitle className="mb-4"> Status Chart </CardTitle>
      <ApexChart
        options={options}
        series={series}
        type="pie"
        height="380"
      />
    </>
  )
}

export default Piechart
